import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import selectAnalytics from './selectAnalytics';
import Price from '../Product/Price';
import Purchase from '../Product/Purchase';
import { listItemCache } from '../../actions/checkout';
import { toggleFavourite } from '../../actions/environment';
import { translate, prefix } from '../../utils/string';
import s from './ProductItem.scss';

const ProductItem = ({ content, id, setup, favourites, currentPath, currentHash, canonical, variation = '', currentView, index, ...props }) => {
	const productItemClasses = [s.productItem, 'u_productItem'];
	const quickShop = variation === 'list' || false;
	const path = canonical ? translate(setup, content, 'canonicalUri') : `${currentPath}/${content.uri}${currentHash}`;
	const soldOutText = content.soldOut && content.soldOut[setup.language] ? content.soldOut[setup.language] : translate(setup, 'soldOut');
	const extraData = {};

	if (content.productHidden || Object.keys(content.categories).length === 0) return null;

	if (!content.inStock) productItemClasses.push(s.productItem__soldOut);
	if (content.price.showAsOnSale) productItemClasses.push(s.productItem__sale);
	if (content.price.newProduct) productItemClasses.push(s.productItem__new);
	if (variation) productItemClasses.push(s[`productItem__${variation}`]);

	const addToFavouritesHandler = (e) => {
		e.preventDefault();
		props.toggleFavourite(id, currentPath);
	};

	const listItemSelectedHandler = () => {
		selectAnalytics(content, setup, currentView, index);
		props.listItemCache(content.id, currentView);
	};

	return (
		<div className={productItemClasses.join(' ')} data-product-id={id} data-product-index={index} {...extraData}>
			<a href="#addToFavourites" onClick={addToFavouritesHandler} className={[s.productItem_favourites, 'a-productItemFavorite'].join(' ')}>
				{ favourites.indexOf(id) === -1 ? <span className={s.productItem_favourites_text}>{ translate(setup, 'addToFavourites') }</span> : null }
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
					<path fill={favourites.indexOf(id) === -1 ? 'none' : '#663886'} stroke="#000" strokeWidth="1.3" d="M82.3607178,44.9685735 C89.1964111,38.2322454 85.5537109,32.7345647 81.5004883,32.0919866 C78.7983398,31.6636012 76.7208802,32.7314723 75.0893698,35.2955999 C73.4578594,32.7314723 71.3803998,31.6636012 68.6782514,32.0919866 C64.6250287,32.7345647 60.9823285,38.2322454 67.8180219,44.9685735 C70.9248433,48.0302334 73.289046,50.256918 75.0893698,51.6486272 C76.8896936,50.256918 79.2538964,48.0302334 82.3607178,44.9685735 Z" transform="translate(-63 -31)" />
				</svg>
			</a>
			<Link className={s.productItem_link} onClick={listItemSelectedHandler} to={prefix(setup, path)}>
				<div className={s.productItem_images}>
					{ content.image.map((image) => <img key={image.slice(image.lastIndexOf('/') + 1)} src={image} width="300" height="400" alt={`${content.brand} ${content.name}`} />) }
				</div>
				<div className={s.productItem_text}>
					<span className={s.productItem_text_brand}>{ content.brand }</span>
					<span className={s.productItem_text_name}>{ content.name }</span>
					<div className={s.productItem_text_price}>
						<Price price={content.price} soldOut={!content.inStock ? soldOutText : false} />
					</div>
				</div>
			</Link>
			{
				quickShop && <div className={s.productItem_purchase}><Purchase setup={setup} currentPath={prefix(setup, path)} productId={id} sizes={content.sizes} instoreOnly={content.instoreOnly} soldOut={!content.inStock ? soldOutText : false} /></div>
			}
		</div>
	);
};

const mapState = ({ environment }, { content, id, currentPath, variation }) => ({
	setup: environment.setup,
	favourites: environment.favourites,
	content,
	id,
	currentPath,
	variation,
});

export default hot(module)(connect(mapState, { toggleFavourite, listItemCache })(ProductItem));
